/* global axios */
import ApiClient from './ApiClient';

class InstitutionsAPI extends ApiClient {
  constructor() {
    super('institutions', { accountScoped: true });
  }

  sync(params = {}) {
    return axios.post(`${this.url}/sync`, params);
  }
}

export default new InstitutionsAPI();
